import React from 'react';
import { FormattedMessage } from 'translations';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';

import style from './style.css';


// Constants
const messages = {
  title: { id: 'BOOK_TRIP.PHONE_MANDATORY.TITLE' },
  text: { id: 'BOOK_TRIP.PHONE_MANDATORY.TEXT' }
};

const PhoneMandatoryBox = () => (
  <InteractiveInfoBlock
    type="blue"
    title={<FormattedMessage {...messages.title} />}
    text={<FormattedMessage {...messages.text} />}
    icon={{ family: 'mozio', name: 'mobile-phone-mandatory' }}
    className={style.block}
  />
);

export default PhoneMandatoryBox;
